import { API } from "app/api";


export function fetchMyCommunityData(data) {
    return API.post('/api/page/myCommunity', data);
}